angular
    .module('app')
    .component('b2bPartners', {
        templateUrl: '/templates/pages/b2bPartners/b2bPartners.html',
        controller: 'B2bPartnersController',
        controllerAs: 'vm',
    });